import { render, staticRenderFns } from "./MyProfilePortfolio.vue?vue&type=template&id=008a8174&scoped=true"
import script from "./MyProfilePortfolio.vue?vue&type=script&lang=js"
export * from "./MyProfilePortfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a8174",
  null
  
)

export default component.exports